import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginService } from '../login.service';

@Component({
  selector: 'app-exam-payer',
  templateUrl: './exam-payer.component.html',
  styleUrls: ['./exam-payer.component.scss'],
  standalone: false
})
export class ExamPayerComponent implements OnChanges {
  @Input() examId: number | null = null;
  payers = ['Leumit', 'Clalit', 'Macabi', 'Meuhedet', 'Private', 'הפניקס', 'כלל', 'איילון', 'הכשרה ביטוח', 'מנורה', 'מגדל'];
  HMO: string | null = null;
  error = false;

  constructor(private http: HttpClient, public ls: LoginService) { }

  async ngOnChanges(changes: SimpleChanges) {
    if (changes.examId && this.examId) {
      await this.load();
    }
  }

  async load() {
    try {
      const result: any = await this.http.get(`/api/financial/payer/${this.examId}`).toPromise();
      this.HMO = this.payers.includes(result.HMO) ? result.HMO : null;
      this.error = false;
    } catch (error) {
      this.error = true;
    }
  }

  async save(value: string | null) {
    const previous = this.HMO;
    this.HMO = value;
    try {
      const result: any = await this.http
        .put('/api/financial/payer', { ExamID: this.examId, HMO: value })
        .toPromise();
      this.HMO = result.HMO;
      this.error = false;
    } catch (error) {
      this.HMO = previous;
      this.error = true;
    }
  }
}
